<div class="cx-product-layout" *ngIf="show" (click)="changeMode()">
  <div [ngClass]="buttonClass">
    <mat-icon
      *ngIf="viewMode === iconTypes.LIST"
      matTooltip="{{ 'buttonTooltip.plp.listViewButton' | cxTranslate }}"
      [matTooltipPosition]="'below'"
      matTooltipClass="icon-tooltip-plp-view "
      svgIcon="list-icon"
    ></mat-icon>
    <mat-icon
      *ngIf="viewMode === iconTypes.GRID"
      matTooltip="{{ 'buttonTooltip.plp.gridViewButton' | cxTranslate }}"
      [matTooltipPosition]="'below'"
      matTooltipClass="icon-tooltip-plp-view"
      aria-label="displays a tooltip in bottom"
      svgIcon="grid-icon"
    ></mat-icon>
  </div>
</div>
